import React from 'react';

import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { PopoverMenu, PopoverMenuItem } from '@futrli/ui-components/components/popover-menu/popover-menu';
import { useSidebarContext } from '@futrli/shared-services/contexts/sidebar-context/useSidebarContext';

interface CreateForecastPopoverProps {
  variant?: 'primary' | 'secondary';
}

export const CreateForecastPopover = ({ variant = 'primary' }: CreateForecastPopoverProps) => {
  const { pAndLBudget, threeWayForecast } = useSidebarContext();

  const items: PopoverMenuItem[] = [
    {
      label: <FormattedMessage id="predict.forecasting.p_and_l_budget" defaultMessage="P&L budget" />,
      onClick: () => pAndLBudget.open()
    },
    {
      label: <FormattedMessage id="predict.create.3_way_forecast_v2" defaultMessage="3-way forecast" />,
      onClick: () => threeWayForecast.open()
    }
  ];

  return (
    <PopoverMenu
      items={items}
      renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }) => (
        <Button
          buttonType={variant}
          iconType="dropdown"
          iconPosition="after"
          onClick={onClick}
          ref={ref}
          aria-expanded={ariaExpanded}
        >
          {variant === 'primary' ? (
            <FormattedMessage id="common.create" defaultMessage="Create" />
          ) : (
            <FormattedMessage id="predict.forecasting.create_forecast" defaultMessage="Create forecast" />
          )}
        </Button>
      )}
    />
  );
};
